import FormBlock from 'models/common/form/FormBlock';

export class FormContentBlock extends FormBlock {}
